// src/pages/Profile.js
import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Alert,
} from "react-bootstrap";
import { getProfile, updateProfile } from "../services/profileService";
import defaultProfilePic from "../assets/profile.jpeg";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [updatedProfile, setUpdatedProfile] = useState({});
  const [profilePic, setProfilePic] = useState(defaultProfilePic); // ✅ FIXED: added missing state
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    // ✅ Load profile picture from localStorage (if any)
    const savedPic = localStorage.getItem("profilePic");
    if (savedPic) {
      setProfilePic(savedPic);
    }

    // ✅ Fetch profile data from backend
    getProfile()
      .then((res) => {
        setProfile(res.data);
        setUpdatedProfile(res.data); // Prefill form with existing data
      })
      .catch((err) => {
        setError("Failed to load profile.");
        console.error(err);
      });
  }, []);

  const handleChange = (e) => {
    setUpdatedProfile({ ...updatedProfile, [e.target.name]: e.target.value });
  };

  const handleUpdate = () => {
    updateProfile(profile.profileId, updatedProfile) // 👈 Make sure profile has `.id`
      .then((res) => {
        setProfile(res.data);
        setMessage("Profile updated successfully!");
        setEditMode(false);
      })
      .catch((err) => {
        setError("Failed to update profile.");
        console.error(err);
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setProfilePic(base64); // show immediately
        localStorage.setItem("profilePic", base64); // persist after refresh
      };
      reader.readAsDataURL(file);
    }
  };

  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!profile) return <p>Loading...</p>;

  return (
    <Container className="mt-4">
      <Card className="p-4 shadow bg-dark text-white">
        <Row>
          {/* Profile Info Section */}
          <Col md={8}>
            <h3 className="mb-4">My Profile</h3>

            {editMode ? (
              <Form>
                {[
                  { label: "Name", name: "name" },
                  { label: "City", name: "currentCity" },
                  { label: "Address", name: "address" },
                  { label: "Contact No", name: "contactNo" },
                  { label: "Email", name: "emailId" },
                  { label: "Date of Birth", name: "dob" },
                  { label: "LinkedIn", name: "linkedln" },
                ].map(({ label, name }) => (
                  <Form.Group className="mb-2" key={name}>
                    <Form.Label>{label}</Form.Label>
                    <Form.Control
                      type="text"
                      name={name}
                      value={updatedProfile[name] || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                ))}

                <div className="d-flex gap-3 mt-3">
                  <Button variant="success" onClick={handleUpdate}>
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => setEditMode(false)}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            ) : (
              <>
                <p>
                  <strong>Name:</strong> {profile.name}
                </p>
                <p>
                  <strong>City:</strong> {profile.currentCity}
                </p>
                <p>
                  <strong>Address:</strong> {profile.address}
                </p>
                <p>
                  <strong>Contact No:</strong> {profile.contactNo}
                </p>
                <p>
                  <strong>Email:</strong> {profile.emailId}
                </p>
                <p>
                  <strong>Date of Birth:</strong> {profile.dob}
                </p>
                <p>
                  <strong>LinkedIn:</strong>{" "}
                  <a
                    href={profile.linkedln}
                    target="_blank"
                    rel="noreferrer"
                    className="text-info"
                  >
                    {profile.linkedln}
                  </a>
                </p>
                <Button variant="warning" onClick={() => setEditMode(true)}>
                  Edit Profile
                </Button>
              </>
            )}

            {message && (
              <Alert variant="success" className="mt-3">
                {message}
              </Alert>
            )}
          </Col>

          {/* Profile Picture Section */}
          <Col md={4} className="text-center">
            <Image
              src={profilePic}
              alt="Profile"
              fluid
              roundedCircle
              className="shadow mb-3"
              style={{ width: "200px", height: "200px", objectFit: "cover" }}
            />

            <Form.Group controlId="formFile" className="mb-2">
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default Profile;
